import React from "react";
import DatePicker from "react-multi-date-picker";
import closeIcon from "../../../../assets/images/icons/circle-x-filled.svg";
import { toast } from 'react-toastify';

const CalendarEvent = ({
  event,
  eventPrice,
  handleEventCard,
  calculatePrice,
  handleFeatureSelect,
  selectedFeature,
  setDateRange,
  setEventPrice,
  setTotalPrice,
  dateRange,
  minDate,
  implementations,
  setIsDatePickerOpen,
}) => {
  // console.log(event)
  const alertConfigurations = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  }
  return (
    <div className="d-flex flex-column w-100 gap-4">
      <img
        src={closeIcon}
        className="close"
        alt="close icon"
        width="24"
        height="24"
        onClick={() => {
          handleEventCard(event, true);
        }}
      />

      <div className="card-head">
        <div className="d-flex align-items-center gap-3">
          <img
            src={event.banner_image}
            alt={event.name}
            width="106"
            height="63"
          />
          <h2 className="pl-3">{event.name}</h2>
        </div>
        {(event?.calculated_price || Object.entries(eventPrice)
            .filter(([key]) => key.startsWith(`${event.id}-`))
            .reduce((sum, [_, val]) => sum + val, 0)) > 0 ? (
          <div className="h4 p-3 event-price">
            ${event?.calculated_price || Object.entries(eventPrice)
            .filter(([key]) => key.startsWith(`${event.id}-`))
            .reduce((sum, [_, val]) => sum + val, 0)}
          </div>
        ) : (
          ""
        )}
      </div>
      <h4 className="event-sub-heading">
        Select the publication(s) you want this event featured on:
      </h4>

      <div className="row featured">
        {implementations
          ?.filter(
            (implementation) =>
              event.hasOwnProperty(implementation) && event[implementation] !== null
          )
          ?.map((implementation, index) => {
            const implData = event[implementation];
            if (Array.isArray(implData)) {
              return implData.map((implItem, idx) => (

                <div className="col-6 col-md-4 col-lg-4" key={`${index}-${idx}`}>
                  <div
                    className={`featured__card ${
                      selectedFeature[event.id]?.includes(`${implementation}-${implItem.id}`) ? "active" : ""
                    }`}
                  >
                    <span
                      className="tooltip-wrapper calendar-event-tooltip"
                      data-title={
                        implementation === "patch_featured_placement"
                          ? `Feature your event on the homepage of ${event[implementation]?.website ?? "patch"}, and highlighted in the ${event[implementation]?.website ?? "patch"} newsletter that goes out daily in your market.`
                          : `Feature your event at the top of ${(event[implementation]?.website ?? "cityspark")?.replace(/[#/]+$/g, "")}.`
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M9 6.5H9.00833M8.16667 9H9V12.3333H9.83333M1.5 9C1.5 9.98491 1.69399 10.9602 2.0709 11.8701C2.44781 12.7801 3.00026 13.6069 3.6967 14.3033C4.39314 14.9997 5.21993 15.5522 6.12987 15.9291C7.03982 16.306 8.01509 16.5 9 16.5C9.98491 16.5 10.9602 16.306 11.8701 15.9291C12.7801 15.5522 13.6069 14.9997 14.3033 14.3033C14.9997 13.6069 15.5522 12.7801 15.9291 11.8701C16.306 10.9602 16.5 9.98491 16.5 9C16.5 7.01088 15.7098 5.10322 14.3033 3.6967C12.8968 2.29018 10.9891 1.5 9 1.5C7.01088 1.5 5.10322 2.29018 3.6967 3.6967C2.29018 5.10322 1.5 7.01088 1.5 9Z"
                          stroke="#DEDEDE"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <img
                      src={implItem.image}
                      alt="featured"
                      onClick={() =>
                        handleFeatureSelect(
                          event.id,
                          `${implementation}-${implItem.id}`,
                          selectedFeature[event.id]?.includes(`${implementation}-${implItem.id}`),
                          event
                        )
                      }
                      className="img-fluid"
                    />
                    <div className="bottom-section">
                      <div className="date-time mb-2">
                        <label className="mb-1">Schedule Your Campaign</label>
                        <DatePicker
                          style={{ height: "32px" }}
                          range
                          minDate={new Date(new Date(minDate).setHours(0, 0, 0, 0))}
                          maxDate={
                            event?.end_date ? new Date(event.end_date).setHours(23, 59, 59, 999) : undefined
                          }        
                          onOpen={() => setIsDatePickerOpen(true)}
                          value={dateRange[`${event.id}-${implementation}-${implItem.id}`] || [null, null]}
                          onChange={(newRange) => {
                            const formattedRange = newRange.map((date) =>
                              date ? new Date(date) : null
                            );
                            const featureKey = `${event.id}-${implementation}-${implItem.id}`;
                            setDateRange((prev) => {
                              const updatedDateRange = { ...prev };
                              updatedDateRange[featureKey] = formattedRange;
                              return updatedDateRange;
                            });
                          }}
                          onClose={() => {
                            const featureKey = `${event.id}-${implementation}-${implItem.id}`;
                            let selectedRange = dateRange[featureKey];
                            const [start, end] = selectedRange;

                            const isValidDate = (d) => d instanceof Date && !isNaN(d);

                            if ((start && !isValidDate(start)) || (end && !isValidDate(end)) || (end < start)) {
                              const errorMessage = end < start ? "End date cannot be earlier than start date." : "Invalid date format selected."
                              handleFeatureSelect(
                                event.id,
                                `${implementation}-${implItem.id}`,
                                true,
                                event
                              )

                              toast.error(errorMessage, alertConfigurations);
                              setIsDatePickerOpen(false);
                              return;
                            }

                            if (selectedRange && selectedRange[0] && !selectedRange[1]) {
                              selectedRange = [selectedRange[0], selectedRange[0]];

                              setDateRange((prev) => {
                                const updatedDateRange = { ...prev };
                                updatedDateRange[featureKey] = selectedRange;
                                return updatedDateRange;
                              });
                            }

                            if (selectedRange && selectedRange[0] && selectedRange[1]) {
                              setDateRange((prev) => ({
                                ...prev,
                                [featureKey]: [new Date(selectedRange[0]), new Date(selectedRange[1])],
                              }));
                              const diffTime = Math.abs(selectedRange[1] - selectedRange[0]);
                              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                              calculatePrice(
                                { id: event.id, price: implItem.price },
                                diffDays + 1,
                                false,
                                implItem.path,
                                selectedRange[0],
                                selectedRange[1],
                                implItem.id
                              );
                            }
                            setIsDatePickerOpen(false);
                          }}
                        />
                      </div>
                      <h5>${implItem.price}/day</h5>
                    </div>
                  </div>
                </div>
              ));
            } else if (implData && typeof implData === "object") {
              // Backward compatibility: render as before if object
              return (
                <div className="col-6 col-md-4 col-lg-4" key={index}>
                  <div
                    className={`featured__card ${
                      selectedFeature[event.id]?.includes(implementation) ? "active" : ""
                    }`}
                  >
                    <span
                      className="tooltip-wrapper calendar-event-tooltip"
                      data-title={`Feature your event on the homepage of ${implData.website}, and highlighted in the ${implData.website} newsletter that goes out daily in your market.`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M9 6.5H9.00833M8.16667 9H9V12.3333H9.83333M1.5 9C1.5 9.98491 1.69399 10.9602 2.0709 11.8701C2.44781 12.7801 3.00026 13.6069 3.6967 14.3033C4.39314 14.9997 5.21993 15.5522 6.12987 15.9291C7.03982 16.306 8.01509 16.5 9 16.5C9.98491 16.5 10.9602 16.306 11.8701 15.9291C12.7801 15.5522 13.6069 14.9997 14.3033 14.3033C14.9997 13.6069 15.5522 12.7801 15.9291 11.8701C16.306 10.9602 16.5 9.98491 16.5 9C16.5 7.01088 15.7098 5.10322 14.3033 3.6967C12.8968 2.29018 10.9891 1.5 9 1.5C7.01088 1.5 5.10322 2.29018 3.6967 3.6967C2.29018 5.10322 1.5 7.01088 1.5 9Z"
                          stroke="#DEDEDE"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <img
                      src={implData.image}
                      alt="featured"
                      onClick={() =>
                        handleFeatureSelect(
                          event.id,
                          implementation,
                          selectedFeature[event.id]?.includes(implementation),
                          event
                        )
                      }
                      className="img-fluid"
                    />
                    <div className="bottom-section">
                      <div className="date-time mb-2">
                        <label className="mb-1">Schedule Your Campaign</label>
                        <DatePicker
                          style={{ height: "32px" }}
                          range
                          minDate={new Date(new Date(minDate).setHours(0, 0, 0, 0))}
                          onOpen={() => setIsDatePickerOpen(true)}
                          value={dateRange[`${event.id}-${implementation}`] || [null, null]}
                          onChange={(newRange) => {
                            const formattedRange = newRange.map((date) =>
                              date ? new Date(date) : null
                            );
                            const featureKey = `${event.id}-${implementation}`;
                            setDateRange((prev) => {
                              const updatedDateRange = { ...prev };
                              updatedDateRange[featureKey] = formattedRange;
                              return updatedDateRange;
                            });
                          }}
                          onClose={() => {
                            const featureKey = `${event.id}-${implementation}`;
                            let selectedRange = dateRange[featureKey];

                            if (selectedRange && selectedRange[0] && !selectedRange[1]) {
                              selectedRange = [selectedRange[0], selectedRange[0]];

                              setDateRange((prev) => {
                                const updatedDateRange = { ...prev };
                                updatedDateRange[featureKey] = selectedRange;
                                return updatedDateRange;
                              });
                            }

                            if (selectedRange && selectedRange[0] && selectedRange[1]) {
                              const diffTime = Math.abs(selectedRange[1] - selectedRange[0]);
                              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                              calculatePrice(
                                { id: event.id, price: implData.price },
                                diffDays + 1,
                                false,
                                implData.path,
                                selectedRange[0],
                                selectedRange[1],
                                implData.id
                              );
                            }
                            setIsDatePickerOpen(false);
                          }}
                        />
                      </div>
                      <h5>${implData.price}/day</h5>
                    </div>
                  </div>
                </div>
              );
            } else {
              return null;
            }
          })}
      </div>
    </div>
  );
};

export default CalendarEvent;